const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  errorLogs: state => state.errorLog.logs,
  roletype: state => state.user.roletype,
  userName: state => state.user.userName,
  endOrgName: state => state.user.endOrgName,
  userStatus:state => state.user.userStatus,
  thirdUrl:state => state.user.thirdUrl,
  ispassGuide:state => state.user.ispassGuide,
  isReadVersion:state => state.user.isReadVersion,
  mediaTimeState:state => state.user.mediaTimeState,
  mediaTimeStateObject:state => state.user.mediaTimeStateObject
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js